function isTokenExpired(token) {
    if (!token) return true;
  
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp * 1000 < Date.now(); // JWT exp je u sekundama
    } catch (e) {
      return true;
    }
  }
  
  import { createRouter, createWebHistory } from 'vue-router'
  
  // ✅ Normalne korisničke strane
  import HomeView from '@/views/HomeView.vue'
  import AboutView from '@/views/AboutView.vue'
  import ResselerView from '@/views/ResselerView.vue'
  import PrivacyPolicy from '@/views/PrivacyPolicy.vue'
  // ✅ Admin deo
  import AdminDashboard from '@/views/admin/AdminDashboard.vue'
  import AdminLogin from '@/views/admin/LoginPage.vue'
  import ContentEditor from '@/views/admin/ContentEditor.vue'
  import PlaylistManager from '@/views/admin/PlaylistManager.vue'
  import DeviceListComponent from '@/views/admin/DeviceListComponent.vue'
  import InstructionsComponent from '@/views/admin/InstructionsComponent.vue';
import ActivateComponent from '@/components/ActivateComponent.vue';
import PlaylistComponent from '@/components/PlaylistComponent.vue';
 import ContactView from '@/views/ContactView.vue';
  import DomaciTV from '@/components/DomaciTVComponen.vue';
  const routes = [
    {
      path: '/',
      name: 'Home',
      component: HomeView
    },
    {
      path: '/about',
      name: 'About',
      component: AboutView
    },
    {
        path: '/reseller',
        name: 'Resseler',
        component: ResselerView
      },
      {
        path: '/policy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy
      },
      {
        path: '/activate',
        name: 'Activate',
        component: ActivateComponent
      },
      {
        path: '/playlist',
        name: 'PlaylistComponent',
        component: PlaylistComponent
      },
      
      {
        path: '/contact',
        name: 'ContactView',
        component: ContactView
      },
          {
      path: '/login',
      redirect: '/admin/login'  // apsolutna putanja
    },
    {
      path: '/admin',
      component: AdminDashboard,
      children: [
    {
      path: '',
      redirect: '/admin/login'  // apsolutna putanja
    },
        {
          path: 'login',
          name: 'AdminLogin',
          component: AdminLogin
        },
            {
          path: 'domaciTV',
          name: 'DomaciTV',
          component: DomaciTV
        },
        {
          path: 'manage',
          name: 'ContentEditor',
          component: ContentEditor,
          meta: { requiresAuth: true }
        },
        {
          path: 'upload',
          name: 'PlaylistManager',
          component: PlaylistManager,
          meta: { requiresAuth: true }
        },
        {
          path: 'devices',
          name: 'DeviceListComponent',
          component: DeviceListComponent,
          meta: { requiresAuth: true }
        },
        {
          path: 'instructions',
          name: 'InstructionsComponent',
          component: InstructionsComponent,
          meta: { requiresAuth: true }
        }
      ]
    }
  ]
  
  const router = createRouter({
    history: createWebHistory(),
    routes
 
      
      
  })
  
  // ✅ Samo OVA beforeEach funkcija
  router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('adminToken');
    const isLoggedIn = !!token && !isTokenExpired(token);
  
    if (to.meta.requiresAuth && !isLoggedIn) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('userData');
      alert('Your session is expiried');
      return next('/admin/login');
    }
  
    next();
  });
  
  export default router;
  